

/* **************************************************** Finishing Schedule Supportive Data */
export interface FSSupportiveData {
    id: number;
    type: "Default" | "Custom" | null;
    title: string | null;
    sub_title: string | null;
    status: 1 | 0;
    document: FSSupportiveDocument | null;
}

export const mapFSSupportiveData = (data: any): FSSupportiveData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSSupportiveData = {
        id: data.id,
        type: data.type || null,
        title: data.title || null,
        sub_title: data.sub_title || null,
        status: data.status,
        document: data.document!==null ? mapFSSupportiveDocument(data.document) : null,
    };

    return res;
};

export const mapFSSupportiveDatas = (data: any[]): FSSupportiveData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }
    

    return data.map(mapFSSupportiveData);
};

/* **************************************************** Finishing Schedule Supportive Document */
export interface FSSupportiveDocument {
    id: number;
    fs_data_id: number;
    supportive_id: number;
    path: string | null;
    extension: string | null;
}

export const mapFSSupportiveDocument = (data: any): FSSupportiveDocument => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSSupportiveDocument = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        supportive_id: data.supportive_id,
        path: data.path || null,
        extension: data.extension || null,
    };

    return res;
};
